var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white"},[_c('main',[_c('div',{staticClass:"max-w-8xl mx-auto py-6 sm:px-6 lg:px-8"},[_c('section',[_c('div',{staticClass:"container max-w-screen-xl mt-8 rounded-lg"},[_c('router-view')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }